import { useEffect, useState } from 'react';
import styles from './Toast.module.css';

const Toast = ({ message, onDone }) => {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const leaveTimer = setTimeout(() => setLeaving(true), 2600);
    const doneTimer = setTimeout(() => onDone(), 3000);
    return () => { clearTimeout(leaveTimer); clearTimeout(doneTimer); };
  }, [onDone]);

  return (
    <div className={`${styles.toast} ${leaving ? styles.toastOut : ''}`} role="status" aria-live="polite">
      <span className={styles.icon}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="7" fill="#52B788"/>
          <path d="M5 8L7 10L11 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
      {message}
    </div>
  );
};

export default Toast;
